/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent } from '../../Shared/Card'
import { RateRadialChart } from '../../../Shared/RateRadialChart'
import { LoadingPlaceholderCardContent } from '../../Shared/LoadingPlaceholderCardContent'
import { CardTitle } from '../../Shared/CardTitle'
import { THEME_COLORS } from '../../../Shared/theme'

const COLORS = {
    GREY: '#808080FF',
    RED: THEME_COLORS.RED,
    ORANGE: '#fb923c',
    GREEN: THEME_COLORS.GREEN,
}

const getColor = (rate) => {
    if (rate === 0) return COLORS.GREY
    if (rate >= 80) return COLORS.GREEN
    if (rate >= 50) return COLORS.ORANGE
    return COLORS.RED
}

const RateCard = ({cardLabel, chartLabel, rate, isLoading}) => {
    const getBorderColor = (rate) => {
        if (isLoading) {
            return 'unset'
        }

        return getColor(rate)
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor(rate)};

            .card-content {
                width: 280px;
                height: 210px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent/>
          ) : (
            <CardContent>
                <CardTitle
                  css={css`
                      margin-top: .25rem;
                  `}
                  title={cardLabel}
                />
                <RateRadialChart
                  label={chartLabel}
                  rate={rate}
                  animationsEnabled
                  getColor={getColor}
                  css={css`
                      margin-top: 1.5rem;
                  `}
                />
            </CardContent>
          )}
      </Card>
    )
}

export { RateCard }
